class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.progress = this.getAttribute('data-progress');
  }

  connectedCallback() {
    setTimeout(() => {
      this.querySelector('[data-progress-line]').style.width = this.progress;
    }, 100);
  }
}
customElements.define('progress-bar', ProgressBar);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change',
      this.debouncedOnChange.bind(this)
    );

    var responseCart = {};
    var alreadyAdded = 0;
    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      async: !1,
      success: function (data) {
        responseCart = data;
      },
    });
    
    // let freeProducts = [47463642300729, 50811151253817];
    
    let freeProducts = [47512241668409];
    let cartProductIds = responseCart.items.map(item => item.id);
    let missingProducts = freeProducts.filter(pid => !cartProductIds.includes(pid));
    
    console.log(responseCart.total_price);
    // if (responseCart.total_price >= 5000) {
    //   if (missingProducts.length > 0) {
    //     missingProducts.forEach(pid => {
    //       this.addFreeProd(pid);
    //     });
    //   }
    // }

    for (let i = 0; i < responseCart.items.length; i++) {
      if (responseCart.items[i].id == "47512241668409") {
        alreadyAdded = 1;
        break;
      }
    }
    
    //if (responseCart.total_price >= 5000) {
      if (!alreadyAdded) {
        // this.addFreeProd(47512241668409);
        //this.addFreeProd(50811151253817);
      }
    //}

    updateFreeShipping();
  }

  addFreeProd(productId) {
    var elements = document.querySelector("cart-drawer");
    console.log(productId);

    function getSectionsToRender() {
      return [
        {
          id: '#cart-counter',
          section: 'cart-counter',
          selector: '#shopify-section-cart-counter'
        },
        {
          id: '#CartDrawer-Body',
          section: 'cart-drawer',
          selector: '#shopify-section-cart-drawer #CartDrawer-Body'
        },
      ];
    }
    //var productId = 47512241668409; // Get the product variant ID
    var quantity = 1; // Set default quantity (can be adjusted for dynamic inputs)
    //Send AJAX request to add product to the cart
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {"id":productId,"quantity":1},
      dataType: "json",
      success: function (response) {
        jQuery.post("/cart/update.js", { updates: { [productId]: 1 } });
        // response["sections"] = elements
        //   .getSectionsToRender()
        //   .map((section) => section.section);
        // console.log(response, elements);
        // elements.renderContents(response);

      const sections = getSectionsToRender();
      const sectionsQuery = sections.map(s => s.section).join(',');

    fetch(`/?sections=${sectionsQuery}`)
      .then(res => res.json())
      .then(data => {
        sections.forEach(({ selector, section }) => {
          const container = document.querySelector(selector);
          if (container) {
            container.innerHTML = data[section];
          }
        });
      });
      },
      error: function (xhr, status, error) {
        alert("Error adding to cart!");
      },
    });
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(this.form);
    formData.append(
      "sections",
      elements.getSectionsToRender().map((section) => section.section)
    );
    formData.append("sections_url", window.location.pathname);
    formData.append("id", productId);
    formData.append("qty", quantity);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        // debugger;
        elements.renderContents(response);
        //console.log(response);
        /*if(response.product_id == 4630803185745){
           this.addFreeProd();
          }*/
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.classList.remove("disabled");
      });
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`,
        section:
          document.getElementById('main-cart-items').dataset.id,
        selector: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        } cart-items`
      },
      {
        id: '#cart-counter',
        section: 'cart-counter',
        selector: '#shopify-section-cart-counter'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender()?.forEach(section => {
          const elementToReplace = document.querySelector(section.selector) || document.querySelector(section.id);


          if (elementToReplace) {
            if (!parsedState.errors) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          } else {
            console.error(`Element with selector ${section.selector} not found`);
          }
        });
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateFreeShipping();
        updateCartCount();
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .querySelectorAll(
          `[data-line-item-error][data-line="${line}"]`
        )
        .forEach(error => {
          error.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.querySelector(`[id*="ProductQuantity-${line}"]`)
              .value
          );
        });
    }

    this.currentItemCount = itemCount;
  }
  
}

customElements.define('cart-items', CartItems);
